import { render, staticRenderFns } from "./PaySetting.vue?vue&type=template&id=b531f33e"
import script from "./PaySetting.vue?vue&type=script&lang=js"
export * from "./PaySetting.vue?vue&type=script&lang=js"
import style0 from "./PaySetting.vue?vue&type=style&index=0&id=b531f33e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports